import { render, staticRenderFns } from "./info-item.vue?vue&type=template&id=3df705e6&scoped=true"
import script from "./info-item.vue?vue&type=script&lang=js"
export * from "./info-item.vue?vue&type=script&lang=js"
import style0 from "./info-item.vue?vue&type=style&index=0&id=3df705e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df705e6",
  null
  
)

export default component.exports